import axiosClient from './axiosClient';

const scheduleApi = {
  createSchedule: (data) => {
    const url = `/schedules`;
    return axiosClient.post(url, data);
  },
  allSchedule: (params) => {
    const url = `/schedules`;
    return axiosClient.get(url, { params });
  },
  getAllSchedule: () => {
    const url = `/schedules/get-all-schedules`;
    return axiosClient.get(url);
  },
  getScheduleById: (id) => {
    const url = `/schedules/${id}`;
    return axiosClient.get(url);
  },
  updateSchedule: (id, data) => {
    const url = `/schedules/${id}`;
    return axiosClient.put(url, data);
  },
  getLesson: (id) => {
    const url = `/units/get-event-units?intake=${id}`;
    return axiosClient.get(url);
  },
  deleteSchedule: (id) => {
    const url = `/schedules/${id}`;
    return axiosClient.delete(url);
  },
  todaySchedule: (data) => {
    const url = `/schedules?begin=${data.begin}&end=${data.end}`;
    return axiosClient.get(url);
  },
  calendarView: (data) => {
    const url = `/schedules/get-all-schedules?begin=${data.begin}&end=${data.end}&status=ACTIVE`;
    return axiosClient.get(url);
  },
  advanceFilter: (data, config) => {
    const url = `/schedules/advance-filter`;
    return axiosClient.post(url, data, config);
  },
};

export default scheduleApi;
